import React , {useState} from 'react';

const Result = ({ success, message }) => {
    return (
        <p className={success ? "success-message" : "error-message"}>
            {message}
        </p>
    )
}

function ContactForm({props , formStyle}) {
    const [ result, setResult ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

    const sendEmail = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResult(null);

        const formData = {
            fullname: e.target.fullname.value,
            email: e.target.email.value,
            phone: e.target.phone.value,
            subject: e.target.subject.value,
            message: e.target.message.value
        };

        try {
            const response = await fetch(`${API_URL}/api/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (data.success) {
                setResult({ success: true, message: data.message || 'Your Message has been successfully sent. We will contact you soon.' });
                e.target.reset();
            } else {
                setResult({ success: false, message: data.message || 'Failed to send message. Please try again.' });
            }
        } catch (error) {
            console.error('Error sending email:', error);
            setResult({ success: false, message: 'Network error. Please check your connection and try again.' });
        } finally {
            setLoading(false);
            setTimeout(() => {
                setResult(null);
            }, 10000);
        }
    };

    return (
        <form className={`${formStyle}`} action="" onSubmit={sendEmail}>
            <div className="form-group">
                <input 
                type="text"
                name="fullname"
                placeholder="Your Name"
                required
                />
            </div>

            <div className="form-group">
                <input 
                type="email"
                name="email"
                placeholder="Email Address"
                required
                />
            </div>

            <div className="form-group">
                <input 
                type="text"
                name="phone"
                placeholder="Phone Number"
                required
                />
            </div>


            <div className="form-group">
                <input 
                type="text"
                name="subject"
                placeholder="Subject"
                required
                />
            </div>

            <div className="form-group">
                <textarea 
                name="message"
                placeholder="Your Message"
                required
                >
                </textarea>
            </div>

            <div className="form-group">
                <button 
                    className="btn-default btn-large" 
                    type="submit"
                    disabled={loading}
                >
                    {loading ? 'Sending...' : 'Submit Now'}
                </button>
            </div> 

            <div className="form-group">
                {result ? <Result success={result.success} message={result.message} /> : null}
            </div> 
        </form>
    )
}
export default ContactForm;
